/**
 * File: usePageErrorController.ts
 * Path: apps/admin/src/modules/app/hooks/usePageErrorController.ts
 * Description: What PageError shows: the crash message and current path. The
 * error is recorded in this device's error log once per message and path.
 */

import { useEffect } from "react";
import { useLocation, useRouteError } from "react-router-dom";
import { logError } from "@/shared/utils/errorLogUtils";

const messageOf = (error: unknown): string =>
  error instanceof Error ? error.message : typeof error === "string" ? error : "Unknown error";

export const usePageErrorController = () => {
  const error = useRouteError();
  const { pathname } = useLocation();
  const message = messageOf(error);

  useEffect(() => {
    logError(message, pathname);
  }, [message, pathname]);

  return { message, pathname, reload: () => window.location.reload() };
};
